import React from 'react'
import ReactDOM from 'react-dom/client'
// Side-effect: registers apiClient with @procoach/shared before any API calls
import './api/client'
import '@shared/index.css'
import App from './App'
import { initMockTelegram } from './utils/mockTelegram'
import { loadMaxBridge } from '@shared/utils/maxBridge'

// Инициализируем мок Telegram в dev режиме
initMockTelegram()

// В MAX сначала мост (window.WebApp с init data), потом рендер: адаптер среды
// и первые запросы читают его сразу. В Telegram и браузере - без ожидания.
void loadMaxBridge().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
